export default __webpack_public_path__ + "assets/d5f1b5467e675a7dd0a7b2e78f858ebb.png";